import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

const initialState = {
    user: localStorage.nome,
    fonte: localStorage.tipo,
    destino: '',
    texto: ''
}

export default class Despacho extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                id: this.props.match.params.id,
                processo: this.props.match.params.id,
                user: localStorage.nome,
                fonte: localStorage.tipo,
                responsavel: '',
                fiscalizado: '',
                destino: '',
                texto: '',
                data: '',
                tipo: '',
                estado: localStorage.estado
            },
            button: false
        }
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    save(e) {
        e.preventDefault()
        const id = this.state.ficha.id
        //Talvez a próxima linha quebre o app em produção!
        var paf = this.props.location.search.slice(1)
        this.setState({ button: true })
        const url = '/api/certidao'
        const ficha = { ...this.state.ficha }
        ficha.tipo = paf
        this.setState({ ficha })
        axios.post(url, ficha)
            .then(res => {
                alert('Sua certidão foi enviada com sucesso!')
                if (this.state.ficha.tipo == 'paf') {
                    window.location = `/documentosPaf/${id}`
                } else {
                    window.location = `/documentos/${id}`
                }
            })
            .catch(error => {
                alert(error.response.data)
                this.setState({ button: false })
            })
    }

    render() {
        return (
            <div className="container mx-auto">
                <div className="form-group row mt-3 text-left">
                    <label className="col-3 col-md-2">Usuário:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" value={this.state.ficha.user} />
                    </div>
                    <label className="col-3 col-md-2">Responsável Técnico:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="responsavel" onChange={e => this.updateField(e)} />
                    </div>
                    <label className="col-3 col-md-2">Fiscalizado:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="fiscalizado" onChange={e => this.updateField(e)} />
                    </div>
                    <label className="col-3 col-md-2">Fonte:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            value={this.state.ficha.fonte.toUpperCase()} />
                    </div>
                    <label className="col-3 col-md-2">Assunto:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="assunto" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Cumprimento de prazo">Cumprimento de prazo</option>
                            <option value="Descumprimento de prazo">Descumprimento de prazo</option>
                            <option value="Cumprimento de obrigação">Cumprimento de obrigação</option>
                            <option value="Descumprimento de obrigação">Descumprimento de obrigação</option>
                            <option value="Situação de processo">Situação de processo</option>
                            <option value="Recebimento de documento">Recebimento de documento</option>
                            <option value="Intersetorial">Intersetorial</option>
                        </select>
                    </div>
                    {this.renderDestino()}
                    {this.renderPrazo()}
                    <label className="col-12">Texto:</label>
                    <textarea type="textarea" rows="8" className="form-control col-12 mb-5"
                        name="texto" onChange={e => this.updateField(e)} />
                    <Button onClick={e => this.save(e)} disabled={this.state.button} />
                </div>
            </div>
        )
    }

    renderPrazo() {
        if (this.state.ficha.destino == "Aguardando prazo") {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Setor Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="setorDestino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Administrativo">Administrativo</option>
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                    <label className="col-3 col-md-2">Fim do prazo:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="date" className="form-control" name="data" onChange={e => this.updateField(e)} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderDestino() {
        if (this.state.ficha.fonte == 'coordenacao') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            {/* <option value="Administrativo">Administrativo</option> */}
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.fonte == 'coordenacao_pb') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            {/* <option value="Administrativo">Administrativo</option> */}
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.fonte == 'vice-presidencia') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            {/* <option value="Administrativo">Administrativo</option> */}
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.fonte == 'juridico') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            {/* <option value="Administrativo">Administrativo</option> */}
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.fonte == 'presidencia') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Presidência">Presidência</option>
                            {/* <option value="Administrativo">Administrativo</option> */}
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.fonte == 'fiscal') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.fonte == 'defis' || this.state.ficha.fonte == 'fiscalAssessor') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Coordenação">Coordenação</option>
                            {/* <option value="Administrativo">Administrativo</option> */}
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.fonte == 'administrativo') {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Destino:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select" name="destino" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Denúncia">Denúncia</option>
                            {/* <option value="Administrativo">Administrativo</option> */}
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
    }
}